module.exports = __webpack_public_path__ + "static/1.9ff8c407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modeling/1.png
// module id = 881
// module chunks = 230667518368419 245178253630338